import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";

const Submenu = (props) => {
  const { featured, items, ...rest } = props;

  return (
    <ul {...rest} className={styles.submenu}>
      {featured && (
        <li key={featured.url}>
          <a className={styles.submenuFeaturedLink} href={featured.url}>
            <img src={featured.image} alt="" />

            <div>
              {featured.title}
              <br />
              <b>{featured.subtitle}</b>
            </div>
          </a>
        </li>
      )}

      {items.map((item) => (
        <li key={item.url}>
          <a className={styles.submenuTextLink} href={item.url}>
            {item.title}
          </a>
        </li>
      ))}
    </ul>
  );
};

Submenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ).isRequired,
  featured: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.string,
  }),
};

Submenu.defaultProps = {
  featured: null,
};

export default Submenu;
